import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentProfessionalCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const pro = ctrl.resolvedProfessional;
  const initials = (pro?.full_name ?? "")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <section className="flex items-center gap-3 rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <Avatar className="size-[42px]">
        <AvatarFallback className="bg-muted text-sm font-bold text-muted-foreground">
          {initials || "—"}
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-semibold text-muted-foreground">
          {t("appointmentForm.responsibleProfessional")}
        </div>
        <div className="mt-px text-[15px] font-bold">
          {pro?.full_name ?? t("appointmentDetails.noProfessionalAssigned")}
        </div>
      </div>
    </section>
  );
}
